import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { SettingsClassificationTypeResponseModel } from 'src/app/shared/models/response/settings/settings-classificationtype-response-model';
import { WebStorageService } from '../../shared/services/web-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ClassificationTypeService extends BaseService {
  ctrl = 'classification-type';
  constructor(private httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  save(item: SettingsClassificationTypeResponseModel) {
    return this.post(this.ctrl, item);
  }

  deleteById(id: number) {
    return this.delete(`${this.ctrl}/${id}`);
  }

  getById(id: number) {
    return this.get(`${this.ctrl}/${id}`);
  }

  getAll() {
    return this.get(this.ctrl);
  }
}
